module.exports = __webpack_public_path__ + "static/img/ART.556c5df2.png";